// extracted by mini-css-extract-plugin
export default {"backgroundimage":"imageelement_backgroundimage__BGZ8x","bgimagecontent":"imageelement_bgimagecontent__SP8Gc"};